<lgb-header-gradient [background]="true"></lgb-header-gradient>
<div class="screen-container" [loading]="!completeLoad()">
	<h1 class="mb-4">Utilisateurs</h1>
	<!-- <p class="title-xs font-serra my-4">Gestion des utiliateurs</p> -->
	<label class="input input-bordered input-lg w-full gap-2">
	  <input 
	  	[(ngModel)]="qSearch"
	  	#searchable="searchable"
	  	[qSearch]="qSearch()"
	  	[search]="getSearchObs()"
	  	[(results)]="users"
	  	[(searching)]="searching"
	  	type="text" 
	  	class="grow placeholder:text-base-content/60"
	  	placeholder="Recherchez un utilisateur..." 
	  />
	  <span (click)="searchable.search()" class="opacity-60"><i class="fa-light fa-sliders"></i></span>
	</label>

	<div class="mt-4 overflow-x-auto">
	  <table class="table">
	    <!-- head -->
	    <thead>
	      <tr>
	        <th>Nom</th>
	        <th>E-mail</th>
	        <th>Droits</th>
	        <th>Inscription</th>
	        <th></th>
	      </tr>
	    </thead>
	    <tbody>
	      <!-- row -->
	      @for(user of users(); track user.ident){
		      <tr>
		        <td>
	              <div class="nowrap font-bold">{{user.name}} {{user.lastname}}</div>
	              <div class="text-sm opacity-50">{{getPays(user.country).name}}</div>
		        </td>
		        <td>
		        	<a href="mailto:anthony@candyss.fr" class="nowrap">{{user.email}}</a>
		        </td>
		        <td>
		          @for(right of user.rights; track right){
		          	<span class="badge badge-ghost badge-sm">{{right}}</span>
		          }
		      	</td>
		      	<td>
		      		{{user.dateCreate | date:'dd/MM/yyyy'}}
		      	</td>
		        <th>
		          <a href="#" [routerLink]="router.parse('admin-user', [user.ident])" class="btn btn-ghost btn-xs">
		          	<i class="text-primary fa-regular fa-pen"></i>
		          </a>
		        </th>
		      </tr>
		  }
	    </tbody>
	  </table>
	</div>

	<div class="pagination mt-4">
		<div class="join">
		  @if(searchable.canPrev()){
		  	<button (click)="searchable.prev()" class="join-item btn">«</button>
		  }
		  <button class="join-item btn">Page {{searchable.page()+1}}</button>
		  @if(searchable.canNext()){
		    <button (click)="searchable.next()" class="join-item btn">»</button>
		  }
		</div>
	</div>
</div>